// eslint-disable-next-line no-restricted-imports
import {
  Message as IMessage,
  MessageCategoryEnum as IMessageCategoryEnum,
  MessageSeverityEnum as IMessageSeverityEnum,
} from '@eih-netbroker/api-notification';

export type Message = IMessage;

export const MessageCategoryEnum = IMessageCategoryEnum;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type MessageSeverityEnum = (typeof MessageSeverityEnum)[keyof typeof MessageSeverityEnum];

export const MessageSeverityEnum = IMessageSeverityEnum;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type MessageCategoryEnum = (typeof MessageCategoryEnum)[keyof typeof MessageCategoryEnum];
